import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import HotelImportsTable from 'components/HotelImportsTable';

import { withData } from 'lib';
import { ToolsHotelImportsPageQuery } from '__generated__/ToolsHotelImportsPageQuery.graphql';

const query = graphql`
  query ToolsHotelImportsPageQuery($first: Int!, $after: String) {
    ...HotelImportsTable_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ToolsHotelImportsPageQuery>;
};

const ToolsHotelImportsPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<ToolsHotelImportsPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { name: 'Įrankiai', link: '/tools' },
        { name: 'Viešbučių importas' },
      ]}>
      <Pagination>
        <HotelImportsTable data={data} />
      </Pagination>
    </Page>
  );
};

export default withData<ToolsHotelImportsPageQuery>({
  query,
})(ToolsHotelImportsPage);
